<div class="facebook-ad-container">
  <!-- Header Section -->
  <div class="ad-header">
    <div class="profile-section">
      <div class="profile-picture">
        <img [src]="logoUrl || '/assets/images/image 29.png'" alt="Profile" class="profile-img">
      </div>
      <div class="profile-info">
        <div class="profile-name">{{ businessName }}</div>
        <div class="sponsored-section">
          <span class="sponsored-label">Sponsored</span>
          <div class="sponsored-dot"></div>
          <div class="globe-icon">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.8 3.5H9.2M0.8 6.5H9.2M4.75 0.5C3.90767 1.84981 3.4611 3.40893 3.4611 5C3.4611 6.59107 3.90767 8.15019 4.75 9.5M5.25 0.5C6.09233 1.84981 6.5389 3.40893 6.5389 5C6.5389 6.59107 6.09233 8.15019 5.25 9.5M0.5 5C0.5 5.59095 0.616396 6.17611 0.842542 6.72208C1.06869 7.26804 1.40016 7.76412 1.81802 8.18198C2.23588 8.59984 2.73196 8.93131 3.27792 9.15746C3.82389 9.3836 4.40905 9.5 5 9.5C5.59095 9.5 6.17611 9.3836 6.72208 9.15746C7.26804 8.93131 7.76412 8.59984 8.18198 8.18198C8.59984 7.76412 8.93131 7.26804 9.15746 6.72208C9.3836 6.17611 9.5 5.59095 9.5 5C9.5 3.80653 9.02589 2.66193 8.18198 1.81802C7.33807 0.974106 6.19347 0.5 5 0.5C3.80653 0.5 2.66193 0.974106 1.81802 1.81802C0.974106 2.66193 0.5 3.80653 0.5 5Z" stroke="#555963" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
                
          </div>
        </div>
      </div>
    </div>
    <div class="header-actions">
      <div class="action-dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>

  <!-- Ad Text -->
  <div class="ad-text">
    {{ discountText }}
  </div>

  <!-- Main Ad Image -->
  <div class="ad-image">
    <img [src]="imageUrl || '/assets/images/Frame 1171276863.png'" alt="Ad Background" class="ad-background-img">
  </div>

  <!-- Call to Action Section -->
  <div class="cta-section">
    <div class="cta-text">{{ discountPercentage || '50% Off' }} </div>
    <button class="cta-button">{{ ctaText || 'Shop Now' }}</button>
  </div>

  <!-- Engagement Metrics -->
  <div class="engagement-metrics">
    <div class="reactions">
      <div class="reaction-icons">
        <div class="reaction-icon like-icon">
          <img src="assets/images/facebook-ad/reaction-like.png" alt="Like" class="reaction-img">
        </div>
        <div class="reaction-icon love-icon">
          <img src="assets/images/facebook-ad/reaction-love.png" alt="Love" class="reaction-img">
        </div>
        <div class="reaction-icon care-icon">
          <img src="assets/images/facebook-ad/reaction-care.png" alt="Care" class="reaction-img">
        </div>
      </div>
      <span class="reaction-count">{{ likes }}</span>
    </div>
    <div class="engagement-stats">
      <span class="comments-shares">{{ comments }} Comments  {{ shares }} Shares</span>
    </div>
  </div>

  <!-- Interaction Buttons -->
  <div class="interaction-buttons">
    <button class="interaction-btn like-btn">
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.83333 6.66732V13.334C3.83333 13.555 3.74554 13.767 3.58926 13.9232C3.43298 14.0795 3.22101 14.1673 3 14.1673H1.33333C1.11232 14.1673 0.900358 14.0795 0.744078 13.9232C0.587797 13.767 0.5 13.555 0.5 13.334V7.50065C0.5 7.27964 0.587797 7.06768 0.744078 6.9114C0.900358 6.75512 1.11232 6.66732 1.33333 6.66732H3.83333ZM3.83333 6.66732C4.71739 6.66732 5.56523 6.31613 6.19036 5.69101C6.81548 5.06589 7.16667 4.21804 7.16667 3.33398V2.50065C7.16667 2.05862 7.34226 1.6347 7.65482 1.32214C7.96738 1.00958 8.39131 0.833984 8.83333 0.833984C9.27536 0.833984 9.69928 1.00958 10.0118 1.32214C10.3244 1.6347 10.5 2.05862 10.5 2.50065V6.66732H13C13.442 6.66732 13.866 6.84291 14.1785 7.15547C14.4911 7.46803 14.6667 7.89196 14.6667 8.33399L13.8333 12.5007C13.7135 13.0119 13.4861 13.4509 13.1855 13.7515C12.8849 14.0521 12.5274 14.198 12.1667 14.1673H6.33333C5.67029 14.1673 5.03441 13.9039 4.56557 13.4351C4.09673 12.9662 3.83333 12.3304 3.83333 11.6673" stroke="#15172E" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
            
      Like
    </button>
    <button class="interaction-btn comment-btn">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.41667 5.00065H12.0833M5.41667 8.33398H10.4167M6.25 12.5007H3.75C3.08696 12.5007 2.45107 12.2373 1.98223 11.7684C1.51339 11.2996 1.25 10.6637 1.25 10.0007V3.33398C1.25 2.67094 1.51339 2.03506 1.98223 1.56622C2.45107 1.09738 3.08696 0.833984 3.75 0.833984H13.75C14.413 0.833984 15.0489 1.09738 15.5178 1.56622C15.9866 2.03506 16.25 2.67094 16.25 3.33398V10.0007C16.25 10.6637 15.9866 11.2996 15.5178 11.7684C15.0489 12.2373 14.413 12.5007 13.75 12.5007H11.25L8.75 15.0007L6.25 12.5007Z" stroke="#15172E" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
            
      Comment
    </button>
    <button class="interaction-btn share-btn">
        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.33349 0.833984V4.16732C3.85432 5.02398 1.81682 9.82398 1.00016 14.1673C0.969324 14.339 5.48682 9.19898 9.33349 9.16732V12.5007L16.0002 6.66732L9.33349 0.833984Z" stroke="#15172E" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
      Share
    </button>
  </div>
</div>